import { useMediaQuery } from '../../hooks/useMediaQuery';
import styles from './HelpTooltip.module.css';

// Wrapper to handle both desktop and mobile tooltips
const HelpTooltip = ({ content, onMobileClick }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  // On mobile, we render a simple button that triggers the BottomSheet in the parent.
  if (isMobile) {
    return (
      <button
        className={styles.infoButton}
        onClick={() => onMobileClick(content)}
      >
        <i className="fas fa-info-circle"></i>
      </button>
    );
  }

  // On desktop, we render the classic CSS-only hover tooltip.
  return (
    <div className={styles.tooltipContainer}>
      <i className={`fas fa-info-circle ${styles.tooltipIcon}`}></i>
      <div className={styles.tooltipText}>{content}</div>
    </div>
  );
};

export default HelpTooltip;
